import KaunJeetaD from "components/vidhansabha/KaunJeetaD";
import { stateData } from "../../../../constants/state";
// import KaunJeetaJK from "components/vidhansabha/KaunJeetaJK";
import NotFound from "pages/404";

export default function kaunJeetaIndex(props) {
  return props.found ? <KaunJeetaD {...props} /> : <NotFound />;
}

export async function getServerSideProps(ctx) {
  const { electionState } = ctx.params;
  console.log(electionState, " plm");

  if(stateData[electionState] == undefined){
    return {
      props : {
        found : false
      }
    }
  }

  const masterKey = stateData[electionState]["masterConfigKey"];

  const masterConfig = await fetch(
    // `https://static.thelallantop.com/json-configs/public/file.json`
    `${process.env.NEXT_PUBLIC_APP_API_URL}/v1/staticData/json/master-config`
  ).then(async (res) => {
    return await res.json();
  });
  // masterConfigData = masterConfig?.data;
  const masterConfigData = masterConfig?.result?.jsonData?.data?.[masterKey];
  // masterConfigData.electionYear_KJKH_listing = 2020
  // console.log("master config data in ssr  ", masterConfigData);

  let winnersData = [];
  let winnersData2024 = [];
  let liveData = [];
  // let state = "haryana"

  //making state dynamic based on the election state
  const state = stateData[electionState]["result"]["state"];
  const stateHindi = stateData[electionState]["result"]["stateHindi"];
  const prevDataUrl = stateData[electionState]["result"]["prevDataUrl"];
  const currentDataUrl =
    stateData[electionState]["result"][
      masterConfigData.electionYear_KJKH_listing
    ];
  const propData = stateData[electionState]["result"];
  const breadCrump = stateData[electionState]["breadCrump"];

  try {
    
    await fetch(currentDataUrl)
      .then(async (data) => {
        const data1 = await data.json();
        winnersData2024 =
          masterConfigData.electionYear_KJKH_listing == propData.currentYear
            ? data1?.data?.seat_data
            : data1?.seat_data;
      })
      .catch((err) => {
        console.log("error in current data url ", err);
      });
  } catch (e) {}

  // try {
  //   await fetch(
  //     "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-2019-all-consituency.json"
  //   ).then(async (data) => {
  //     const data1 = await data.json();
  //     winnersData = data1?.seat_data;
  //   });
  //   await fetch(
  //     "https://electionresults.intoday.in/elections/2024/assembly-elections/json/state/haryana-all-consituency.json"
  //   ).then(async (data) => {
  //     const data1 = await data.json();
  //     winnersData2024 = data1?.data?.seat_data;
  //   });
  // } catch (e) {}

  return {
    props: {
      winnersDataList: winnersData || [],
      stateName: state,
      stateHindi: stateHindi,
      electionState,
      propData,
      masterKey,
      breadCrump,
      found: stateData[electionState] ? true : false,
      winnersData2024: winnersData2024 || [],
    },
  };
}
